import React from 'react'
import { connect } from 'react-redux'
import { reset } from 'redux-form'
import { Button } from 'reactstrap';

const RemoteSaveButton = ({ dispatch , submit }) => (
  <Button
    color="primary" 
    type="submit"
    onClick={() => {
        var res = submit();
        if(res){
            dispatch(reset('third_party_form'));
        }
    }}
  >
    Guardar
  </Button>
)

export default connect()(RemoteSaveButton)